import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AbstractControl} from '@angular/forms';

import {isPresent} from '../../../utils/lang';

/**
 * A step in a wizard.
 *
 * @see WizardComponent for a full usage example
 */
@Component({
  selector: 'gp-wizard-step',
  template: `
    <div [attr.data-hidden]="!active">
      <ng-content></ng-content>
    </div>
  `
})
export class WizardStepComponent {

  public number: number = 0;

  public completed: boolean = false;

  @Output()
  public deactivated: EventEmitter<void> = new EventEmitter<void>();

  @Input()
  public disabled: boolean = false;

  @Input()
  private form: AbstractControl | AbstractControl[];

  @Input()
  public name: string;

  @Input()
  private forceValid: (() => boolean) | boolean = null;

  public loading: boolean = false;

  private _active: boolean = false;

  get active() {
    return this._active;
  }

  get valid(): boolean {
    if (isPresent(this.forceValid) &&
      (typeof this.forceValid === 'function' && this.forceValid() || this.forceValid)) {
      return true;
    }
    if (this.loading) {
      return false;
    }
    return !this.form || (Array.isArray(this.form) ?
      this.form.every(control => control.valid) : this.form.valid);
  }

  public deactivate() {
    this._active = false;
    this.deactivated.emit();
  }

  public activate() {
    this._active = true;
    this.completed = false;
  }
}
